import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Page from '../../../components/Page';
import DataTable from '../../../components/DataTable';
import BlankState from './../../../components/BlankState';
import { TabHolder, Tab } from '../../../components/Tabs';
import DateRangePicker from 'react-bootstrap-daterangepicker';

import { listCurrencies, listCurrencyRates } from '../../../actions/currencies';

class CurrencyRates extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currencies: {}
    };
  }

  componentDidMount() {
    this.props.listCurrencies();
    this.props.listCurrencyRates();
  }

  onChange = e => {
    e.preventDefault();

    const { currencies } = this.state;
    const { name, value } = e.target;

    this.setState({
      currencies: {
        ...currencies,
        [name]: value
      }
    });
  };

  render() {
    const { currency } = this.props;

    const menuItems = [
      { id: 'currency_rates', name: 'Currency Rates', active: true },
      { id: 'currencies', name: 'Available Currencies' },
      { id: 'weekly_rate', name: 'Add Weekly Rates' }
    ];

    return (
      <Page isAdminPage={true} pageTitle="Currency Rates Watch">
        <div className="clearfix">
          <TabHolder menuItems={menuItems}>
            <Tab menuId={menuItems[0].id} isActive={true}>
              {currency.rates.length > 0 ? (
                <DataTable
                  tableId="currency-rates-table"
                  columnTitles={[
                    'Name',
                    'Value',
                    'Currency Code',
                    'Symbol',
                    'Country',
                    'Status',
                    'Effective Date',
                    'Created'
                  ]}
                >
                  {currency.rates
                    ? currency.rates.map(rate => {
                        return (
                          <tr key={rate.id}>
                            <td>{rate.currency_name}</td>
                            <td>
                              <pre>{rate.rate}</pre>
                            </td>
                            <td>{rate.currency_code}</td>
                            <td>{rate.currency_symbol}</td>
                            <td>{rate.currency_name}</td>
                            <td>
                              <span className="badge badge-success">
                                {rate.status ? 'Active' : 'In-Active'}
                              </span>
                            </td>
                            <td>{rate.effective_date}</td>
                            <td>{rate.date}</td>
                          </tr>
                        );
                      })
                    : null}
                </DataTable>
              ) : (
                <BlankState
                  data={currency.rates}
                  dataName="Currency Rates"
                  isDataLoading={currency.loadingRates}
                />
              )}
            </Tab>

            <Tab menuId={menuItems[1].id}>
              <div className="panel">
                <div className="page-body">
                  {currency.currencies.length > 0 ? (
                    <DataTable
                      tableId="available-currencies"
                      columnTitles={[
                        'Name',
                        'Currency Code',
                        'Symbol',
                        'Country'
                      ]}
                    >
                      {currency.currencies.map(currency => {
                        return (
                          <tr key={currency.id}>
                            <td>{currency.name}</td>
                            <td>
                              <pre>{currency.code}</pre>
                            </td>
                            <td>
                              <pre>{currency.symbol}</pre>
                            </td>
                            <td>{currency.country_name}</td>
                          </tr>
                        );
                      })}
                    </DataTable>
                  ) : (
                    <BlankState
                      data={currency.rates}
                      dataName="Available currencies"
                      isDataLoading={currency.loadingCurrencies}
                    />
                  )}
                </div>
              </div>
            </Tab>
            <Tab menuId={menuItems[2].id}>
              <div className="panel">
                <div className="page-body">
                  <form onSubmit={this.handleSubmit}>
                    <div className="form-group">
                      <label className="control-label col-md-2">
                        Date Effective : <span className="text-danger">*</span>
                      </label>
                      <div className="col-md-4">
                        <DateRangePicker
                          singleDatePicker
                          locale={{ format: 'YYYY-MM-DD' }}
                          onApply={this.onChange}
                        >
                          <input
                            type="text"
                            name="date_effective"
                            className={'form-control date-picker-control '}
                            style={{ width: '100%' }}
                          />
                        </DateRangePicker>
                      </div>
                    </div>
                    <table className="table">
                      <thead className="thead-dark">
                        <tr>
                          <th scope="col">Currency Name</th>
                          <th scope="col">Value (*)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currency.currencies
                          ? currency.currencies.map(currency => {
                              return (
                                <tr key={currency.id}>
                                  <td>
                                    <pre>{currency.name}</pre>
                                  </td>
                                  <td>
                                    <input
                                      type="number"
                                      className="form-control"
                                      name={currency.id}
                                      onChange={this.onChange}
                                      value={0 || currency.value}
                                      placeholder={currency.name + ' Value'}
                                      min="1"
                                      required
                                    />
                                  </td>
                                </tr>
                              );
                            })
                          : null}
                      </tbody>
                    </table>
                    &nbsp;
                    <div className="form-group pull-right">
                      <div className="col-sm-8 col-sm-offset-1">
                        <button type="submit" className="btn btn-success">
                          <i className="icon ion-checkmark" /> Save Changes
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </Tab>
          </TabHolder>
        </div>
      </Page>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: state.user,
  currency: state.currency
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators({ listCurrencies, listCurrencyRates }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(CurrencyRates);



// WEBPACK FOOTER //
// ./src/pages/dashboard/rates/CurrencyRates.js